import { connect } from 'react-redux';
import { RootState } from '../api';
import ProfileHeader, {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../components/Profile/ProfileHeader';

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  (
    {
      users: { onlineUsersIds },
      authentication: { isLoggedIn },
      user: { role },
    },
    { profileId },
  ) => ({
    isOnline: onlineUsersIds.includes(profileId),
    loggedIn: isLoggedIn,
    myRole: role || undefined,
  }),
)(ProfileHeader);
